class CartTool extends HTMLElement {
  constructor() {
    super();
    const buttons = this.querySelectorAll('.cartTool-item');
    buttons.forEach((button) => {
      button.addEventListener('click',(event) => {
        // The tools are buttons now (#32): read the button, not whatever was under the pointer,
        // and take the keyboard into the panel that opens.
        const id = event.currentTarget.dataset.popup;
        const panel = document.getElementById(id);
        panel.classList.add('show');
        document.querySelector('.previewCart').classList.add('active-tool');
        panel.querySelector('textarea, input:not([type=hidden]), button')?.focus();
      })
    })
  }
}

customElements.define('cart-item-tool', CartTool);

class CartCancel extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('button').addEventListener('click',(event) => {
      const panel = document.querySelector('.popup-toolDown.show');
      panel.classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
      // Back to the tool that opened the panel (#32).
      document.querySelector(`.cartTool-item[data-popup="${panel.id}"]`)?.focus();
    })
  }
}

customElements.define('cart-cancel-popup', CartCancel);

class CartNote extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('[data-update-note]').addEventListener('click', (event) => {
      this.val = this.querySelector('.text-area').value;
      const body = JSON.stringify({ note: this.val });
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-note', CartNote);

class CouponCode extends HTMLElement {
  constructor() {
    super();
    if (localStorage.getItem('storedDiscount')){
      this.querySelector('input[name="discount"]').value = localStorage.getItem('storedDiscount');  
    }
    this.querySelector('[data-update-coupon]').addEventListener('click', (event) => {
      this.val = this.querySelector('input[name="discount"]').value;
      localStorage.setItem('storedDiscount', this.val);
      fetch(`/discount/${this.val}`)
          .then((response) => response.text())
          .then((responseText) => {
            Shopify.getCart((cart) => {window.sharedFunctions?.updateSidebarCart(cart)});
          });
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('coupon-code', CouponCode);

// The cart drawer and the keyboard (#32). While the drawer is open, focus stays in it:
// it moves to the close button when the drawer opens, Tab and Shift+Tab come round inside
// it, Escape closes it, and closing gives focus back to what opened it. A quantity change
// redraws the drawer's contents, which drops the focused control: focus comes back to the
// same control on the same line, or to the close button when the line has gone.
(() => {
  const drawer = document.getElementById('halo-cart-sidebar');
  if (!drawer) return;
  const body = document.body;
  const isOpen = () => body.classList.contains('cart-sidebar-show');
  const focusable = () => Array.from(drawer.querySelectorAll(
    'a[href], button:enabled, input:not([type=hidden]):enabled, textarea:enabled, select:enabled, [tabindex]:not([tabindex^="-"])'
  )).filter((el) => el.tabIndex >= 0 && (el.checkVisibility
    ? el.checkVisibility({ visibilityProperty: true, opacityProperty: true })
    : el.offsetParent !== null && getComputedStyle(el).visibility !== 'hidden'));
  const closeButton = () => drawer.querySelector('[data-close-cart-sidebar]');
  let opener = null;
  let last = null; // { line, index } of the control last focused inside a cart line

  new MutationObserver(() => {
    if (isOpen() && !opener) {
      opener = document.activeElement && document.activeElement !== body ? document.activeElement : null;
      opener = opener || body;
      if (!drawer.contains(document.activeElement)) closeButton()?.focus();
    } else if (!isOpen() && opener) {
      const back = opener;
      opener = null;
      last = null;
      if (drawer.contains(document.activeElement) || document.activeElement === body) {
        if (back !== body && back.isConnected) back.focus();
      }
    }
  }).observe(body, { attributes: true, attributeFilter: ['class'] });

  // Focus that leaves by a click elsewhere is not brought back; focus dropped by a redraw is.
  drawer.addEventListener('focusout', (event) => {
    if (event.relatedTarget) return;
    const el = event.target;
    queueMicrotask(() => { if (el.isConnected) last = null; });
  });

  drawer.addEventListener('focusin', (event) => {
    const row = event.target.closest('.previewCartItem');
    const line = row?.querySelector('[data-line]')?.dataset.line;
    last = line ? { line, index: Array.from(row.querySelectorAll('a[href], button, input:not([type=hidden])')).indexOf(event.target) } : null;
  });

  new MutationObserver(() => {
    if (!isOpen() || !last || (document.activeElement && document.activeElement !== body)) return;
    const row = Array.from(drawer.querySelectorAll('.previewCartItem'))
      .find((r) => r.querySelector(`[data-line="${CSS.escape(last.line)}"]`));
    const target = row ? row.querySelectorAll('a[href], button, input:not([type=hidden])')[last.index] : closeButton();
    target?.focus();
  }).observe(drawer, { childList: true, subtree: true });

  document.addEventListener('keydown', (event) => {
    if (!isOpen()) return;
    if (event.key === 'Escape') {
      closeButton()?.click();
      return;
    }
    if (event.key !== 'Tab') return;
    const els = focusable();
    if (!els.length) return;
    const first = els[0];
    const end = els[els.length - 1];
    const here = document.activeElement;
    if (!drawer.contains(here)) {
      event.preventDefault();
      (event.shiftKey ? end : first).focus();
    } else if (event.shiftKey && here === first) {
      event.preventDefault();
      end.focus();
    } else if (!event.shiftKey && here === end) {
      event.preventDefault();
      first.focus();
    }
  });
})();